class HurryUpSection extends HTMLElement {
  constructor() {
    super();
    this.interval = null;
    this.countdownDuration = parseInt(this.dataset['duration'], 10) || 600; // seconds
    this.timeLeft = this.countdownDuration;
    this.activeIndex = 0; // will be overridden later in connectedCallback
  }

  connectedCallback() {
    this.timerWrappers = this.querySelectorAll(".countdown_timer_section__wrapper");
    this.hurryUpBlocks = this.querySelectorAll(".hurry-up-section-items-wrapper");

    if (this.hurryUpBlocks.length === 0) return;

    // Set a random active index AFTER DOM is available
    this.activeIndex = Math.floor(Math.random() * this.hurryUpBlocks.length);

    this.startCountdown();
  }

  disconnectedCallback() {
    if (this.interval) clearInterval(this.interval);
  }

  startCountdown() {
    this.updateCountdown();
    this.interval = setInterval(() => this.updateCountdown(), 1000);
  }

  updateCountdown() {
    // Format countdown
    const minutes = Math.floor(this.timeLeft / 60);
    const seconds = this.timeLeft % 60;
    const formattedMinutes = String(minutes).padStart(2, "0");
    const formattedSeconds = String(seconds).padStart(2, "0");

    // Update countdown display
    this.timerWrappers.forEach(wrapper => {
      const minEl = wrapper.querySelector(".minutes");
      const secEl = wrapper.querySelector(".seconds");
      if (minEl && secEl) {
        minEl.textContent = formattedMinutes;
        secEl.textContent = formattedSeconds;
      }
    });

    // Update block visibility
    this.hurryUpBlocks.forEach((block, index) => {
      const isActive = index === this.activeIndex;
      block.classList.toggle("active", isActive);
      block.toggleAttribute("aria-hidden", !isActive);
      block.toggleAttribute("inert", !isActive);
    });

    // Countdown tick
    this.timeLeft--;

    // Transition to next block
    if (this.timeLeft < 0) {
      this.timeLeft = this.countdownDuration;
      this.activeIndex = (this.activeIndex + 1) % this.hurryUpBlocks.length;
    }
  }
}

customElements.define("hurry-up-section", HurryUpSection);

// Shopify theme editor support
document.addEventListener("shopify:section:unload", (event) => {
  event.target.querySelectorAll("hurry-up-section").forEach(el => {
    if (el.interval) clearInterval(el.interval);
  });
});